/**
 * HemSyd Favoriter — delad datahämtning + kort-rendering.
 * Används av: assets/hs-favorites-page.js (sidan "Mina favoriter")
 *             assets/hs-favorites-drawer.js (sido-panelen i header)
 * Kräver window.HS_FAV_TOKEN + window.HS_FAV_API.
 */
(function () {
  'use strict';

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
    return (cents / 100).toLocaleString('sv-SE', { style: 'currency', currency: currency });
  }

  function fetchFavorites() {
    if (!window.HS_FAV_TOKEN) return Promise.resolve([]);
    return fetch(window.HS_FAV_API + '/favorites/list.php?token=' + encodeURIComponent(window.HS_FAV_TOKEN))
      .then(function (r) { return r.json(); })
      .then(function (json) { return (json.ok && json.data && json.data.items) || []; })
      .catch(function () { return []; });
  }

  function fetchProducts(items) {
    return Promise.all(items.map(function (item) {
      return fetch('/products/' + item.product_handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) { return products.filter(Boolean); });
  }

  function variantOf(product) {
    return (product.variants && product.variants[0]) || null;
  }

  /**
   * Lägger produkten i varukorgen via AJAX (ingen sidladdning), visar bock
   * i knappen 1.5s, återgår sedan. Uppdaterar sitens cart_count-element.
   */
  function addToCartAjax(variantId, buttonEl, originalHtml) {
    if (buttonEl.classList.contains('is-loading') || buttonEl.classList.contains('is-added')) return;
    buttonEl.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        buttonEl.classList.remove('is-loading');
        buttonEl.classList.add('is-added');
        buttonEl.innerHTML = CHECK_SVG;
        refreshCartBadge();
        setTimeout(function () {
          buttonEl.classList.remove('is-added');
          buttonEl.innerHTML = originalHtml;
        }, 1500);
      })
      .catch(function () {
        buttonEl.classList.remove('is-loading');
      });
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart_count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { /* ignore */ });
  }

  // Sitens egna "Lägg i varukorgen"-formulär (produktkort/produktsida) triggar
  // inte vår badge-uppdatering direkt - lyssna globalt och uppdatera efteråt.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('formAddToCart')) {
      setTimeout(refreshCartBadge, 800);
    }
  }, true);

  /**
   * Fullt produktkort — exakt samma klasser/struktur som snippets/product-grid-item.liquid,
   * så det ärver kollektionsgridens CSS rakt av. Använd på sidan "Mina favoriter".
   */
  function buildGridCard(product) {
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var variant = variantOf(product);
    var variantId = variant ? variant.id : '';
    var available = variant ? variant.available : product.available;
    var price = variant ? variant.price : product.price;
    var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
    var onSale = comparePrice && comparePrice > price;
    var title = escapeHtml(product.title);

    var el = document.createElement('div');
    el.className = 'velaProBlock grid';
    el.setAttribute('data-price', String(price / 100));
    el.innerHTML =
      '<div class="velaProBlockInner box2">' +
        '<div class="proHImage d-flex flexJustifyCenter proimgh">' +
          '<a class="proFeaturedImage" href="/products/' + product.handle + '" aria-label="' + title + '">' +
            '<div class="wrap proSwatch">' +
              (img ? '<img loading="lazy" class="product-card__image img-responsive" src="' + img + '&width=600" alt="' + title + '">' : '') +
            '</div>' +
          '</a>' +
          '<button type="button" class="hsFavBtn is-favorited" data-hs-fav-id="' + product.id + '" data-hs-fav-handle="' + product.handle + '" aria-label="Ta bort favorit" aria-pressed="true">' +
            '<svg viewBox="0 0 24 24" class="hsFavBtn-outline" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
            '<svg viewBox="0 0 24 24" class="hsFavBtn-filled" fill="currentColor"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
          '</button>' +
          (!available ? '<label class="labelVailable">Slut i lager</label>' : '') +
        '</div>' +
        '<div class="proContent">' +
          '<div class="proName cnn"><a href="/products/' + product.handle + '">' + title + '</a></div>' +
          '<div class="groupPrice clearfix mm3">' +
            '<div class="proPrice">' +
              (onSale
                ? '<div class="priceProduct2">' + money(price) + '</div><div class="priceProduct priceCompare">' + money(comparePrice) + '</div>'
                : '<div class="priceProduct">' + money(price) + '</div>') +
            '</div>' +
            (available
              ? '<button type="button" class="btn btnAddToCart hsBuyBtn" data-variant-id="' + variantId + '"><span class="text">Köp</span></button>'
              : '<button type="button" class="btn btnAddToCart disabled" disabled><span class="text">Slut i lager</span></button>') +
          '</div>' +
        '</div>' +
      '</div>';

    var buyBtn = el.querySelector('.hsBuyBtn');
    if (buyBtn) {
      var original = buyBtn.innerHTML;
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCartAjax(variantId, buyBtn, original);
      });
    }

    bindRemove(el.querySelector('.hsFavBtn'), product, function () { el.remove(); });
    return el;
  }

  /**
   * Kompakt rad-kort för sido-panelen (thumbnail + titel + pris + Köp).
   */
  function buildDrawerRow(product) {
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var variant = variantOf(product);
    var variantId = variant ? variant.id : '';
    var available = variant ? variant.available : product.available;
    var price = variant ? variant.price : product.price;
    var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
    var onSale = comparePrice && comparePrice > price;
    var title = escapeHtml(product.title);

    var el = document.createElement('div');
    el.className = 'hsFavRow';
    el.setAttribute('data-variant-id', variantId);
    el.setAttribute('data-price', String(available ? price : 0));
    el.innerHTML =
      '<a href="/products/' + product.handle + '" class="hsFavRow-img">' +
        (img ? '<img src="' + img + '&width=300" alt="' + title + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="hsFavRow-body">' +
        '<div class="hsFavRow-top">' +
          '<a href="/products/' + product.handle + '" class="hsFavRow-title">' + title + '</a>' +
          '<button type="button" class="hsFavRow-remove" data-hs-fav-id="' + product.id + '" data-hs-fav-handle="' + product.handle + '" aria-label="Ta bort favorit">' +
            '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="hsFavRow-stock ' + (available ? 'is-available' : 'is-unavailable') + '">' +
          (available ? '● Finns i lager' : '● Slut i lager') +
        '</div>' +
        '<div class="hsFavRow-priceRow">' +
          '<div class="hsFavRow-price">' +
            '<span class="hsFavRow-priceNow">' + money(price) + '</span>' +
            (onSale ? '<span class="hsFavRow-priceOld">' + money(comparePrice) + '</span>' : '') +
          '</div>' +
          (available
            ? '<button type="button" class="hsFavRow-buy" data-variant-id="' + variantId + '">Köp</button>'
            : '<button type="button" class="hsFavRow-buy" disabled>Slut</button>') +
        '</div>' +
      '</div>';

    var buyBtn = el.querySelector('.hsFavRow-buy');
    if (buyBtn && available) {
      var original = buyBtn.innerHTML;
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCartAjax(variantId, buyBtn, original);
      });
    }

    bindRemove(el.querySelector('.hsFavRow-remove'), product, function () { el.remove(); });
    return el;
  }

  function bindRemove(btnEl, product, onRemoved) {
    if (!btnEl) return;
    btnEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      btnEl.classList.add('is-loading');
      window.HSFavorites.toggle(product.id, product.handle, btnEl, function (favorited) {
        if (!favorited) onRemoved();
      });
    });
  }

  window.HSFavShared = {
    fetchFavorites: fetchFavorites,
    fetchProducts: fetchProducts,
    buildGridCard: buildGridCard,
    buildDrawerRow: buildDrawerRow,
    addToCartAjax: addToCartAjax,
    refreshCartBadge: refreshCartBadge,
    money: money
  };
})();
